const API_URL = import.meta.env.VITE_API_URL
// const API_URL = "https://nds.accountsdeck.com/api"

function setAccessToken(token) {
  localStorage.setItem('token', token)
}
function getAccessToken() {
  return localStorage.getItem('token')
}

function setUser(user) {
  localStorage.setItem('user', JSON.stringify(user))
}
function getUser() {
  const user = localStorage.getItem('user')
  return user ? JSON.parse(user) : null
}


async function verifyAdminUser(phone) {
  const resp = await fetch(API_URL+"/auth/checkAdminUser", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({phone}),
  })
   const data = await resp.json(); 
  // console.log("Verify response:", data);
  return data;
}

async function sendOtp(phone) {
  const resp = await fetch(API_URL+"/auth/sendOtp", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({phone}),
  })
   const data = await resp.json(); 
  // console.log("Otp response:", data);
  return data;
}

async function verifyOtp(phone,refNo,otp) {
  const resp = await fetch(API_URL+"/auth/verifyOtp", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({phone,refNo,otp}),
  })
   const data = await resp.json(); 
  // console.log("Otp verify response:", data);
  return data;
}

async function registerUser({fullname, email, phone, gender, password,verified}) {
  const resp = await fetch(API_URL+"/auth/register", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({fullname, email, phone, gender, password,verified}),
  })
   const data = await resp.json(); 
  // console.log("Register response:", data);
  return data;
}

async function loginUser({email, password}) {
  const resp = await fetch(API_URL+"/auth/login", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({email, password}),
  })
  const data = await resp.json();
  // console.log("Response body:", data);
  if (data.accessToken) {
    setAccessToken(data.accessToken)
    await fetchUserDetails()
  }
  return data
}

async function loginGoogleUser({email, verified}) {
  const resp = await fetch(API_URL+"/auth/googlelogin", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({email, verified}),
  })
  const data = await resp.json();
  // console.log("Response body:", data);
  if (data.accessToken) {
    setAccessToken(data.accessToken)
    await fetchUserDetails()
  }
  return data
}

async function forgotPassword({email}) {
  const resp = await fetch(API_URL+"/auth/forgot-password", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({email}),
  })
  const data = await resp.json();
  // console.log("Response body:", data);
  // if (data.accessToken) {
  //   setAccessToken(data.accessToken)
  //   await fetchUserDetails()
  // }
  return data
}

async function resetPassword({token,password}) {
  const resp = await fetch(API_URL+"/auth/reset-password", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({token,password}),
  })
  const data = await resp.json();
  // console.log("Response body:", data);
  return data
}

async function registerUserWithGoogle({token}) {
  const resp = await fetch(API_URL+"/auth/google", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({token}),
  })
   const data = await resp.json(); 
  // console.log("Google Register response:", data);
  return data;
}

function logoutUser() {
  localStorage.clear()
}

async function createSession(key,value) {
  // console.log("key",key);
  // console.log("value",value);
  const resp = await fetch(API_URL+"/auth/session", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify({key,value}),
  })
   const data = await resp.json(); 
  // console.log("Session response:", data);
  return data;
}


async function createUserCart(cartData) {
  const resp = await fetch(API_URL+"/carts", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
    body: JSON.stringify(cartData),
  })
   const data = await resp.json();
  // console.log("new cart",data);
  return data;
}

async function getUserCart() {
  const userID = getUser()._id
  const resp = await fetch(API_URL+"/carts/"+userID, {
    credentials: "include",
    headers: {
      "x-access-token": getAccessToken(),
    }
  })
  const cart = await resp.json()

  if(!cart){
    return null;
  }
  
  if (cart.products) {
    cart.products = cart.products.map(p => (
      {
        id: p.product?._id,
        itemId: p.product?.itemId,
        title: p.product?.iName,
        price: p.product?.tranRate,
        image: p.product?.imgPath,
        quantity: p.quantity,
        taxId: p.product?.taxId,
        taxLedId: p.product?.taxLedId,
        taxOn: p.product?.taxOn,
        taxRate: p.product?.taxRate,
        type: p.product?.type,
        style: p.product?.style,
        type_id: p.product?.type_id,
        style_id: p.product?.style_id,
        delCharge: p.product?.delCharge,
        balance: p.product?.balance
      }
    ))
  }
  return cart
}

async function addProductsToCart(products) {
  const userID = getUser()._id
  const resp = await fetch(API_URL+"/carts/"+userID, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
    body: JSON.stringify({products}),
  })
  const data = await resp.json();
  // console.log("ui cart",data);
  return data;
}

async function removeProductFromCart(productID) {
  return await patchCart(productID, 0)
}

async function patchCart(productID, quantity) {
  const userID = getUser()._id
  const resp = await fetch(API_URL+"/carts/"+userID, {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
    body: JSON.stringify({productID, quantity}),
  })
  const data = await resp.json();
  // console.log(data);
  return data;
}

async function clearCart() {
  const resp = await fetch(API_URL+"/carts/clear", {
    method: "POST",
     credentials: "include",
    headers: {
      "x-access-token": getAccessToken(),
    },
  })
  return await resp.json()
}

async function updateCart(updatedData) {
  const userID = getUser()._id
  const resp = await fetch(API_URL+"/carts/update/"+userID, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
    body: JSON.stringify({
      updatedData
    }),
  })
  const data = await resp.json();
  // console.log("ui cart",data);
  return data;
}

async function fetchUserDetails() {
  const resp =  await fetch(API_URL+"/users/me", {
    credentials: "include",
    headers: {
      "x-access-token": getAccessToken(),
    }
  })
  const {status, user} = await resp.json()
  if (status == "ok") {
    if (!user.avatarSrc) {
      user.avatarSrc = `https://api.dicebear.com/7.x/adventurer-neutral/svg?seed=${encodeURIComponent(user.fullname)}`
    }
    setUser(user)
  }
  return {status, user}
}

async function editUser(user) {
  const userID = getUser()._id
  const resp = await fetch(API_URL+"/users/"+userID, {
    method: "PUT",
     credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
    body: JSON.stringify({user}),
  })
  const data = await resp.json();
  // console.log("edited user",data);
  return data;
}


async function fetchProducts(category, newArrivals = false, includeChildren = false) {
  // Build query string
  let query = `new=${newArrivals ? "true" : "false"}`;       // same as before
  if (category) query += `&category=${category}`;           // add category if provided
  if (includeChildren) query += `&includeChildren=true`;    // add children flag only if true
  // console.log("product query",query)
  const resp = await fetch(`${API_URL}/products?${query}`);
  return await resp.json();
}

async function fetchProduct(id) {
  const resp = await fetch(API_URL+"/products/"+id)
  return await resp.json()
}

async function fetchCategories() {
  const resp = await fetch(API_URL+"/products/category")
  return await resp.json()
}

async function proceedCheckout() {
  const resp = await fetch(API_URL+"/checkout/payment", {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
  })
  const data = await resp.json();
  return data
}

async function fetchUserAddress() {
  const userID = getUser()._id
  const resp = await fetch(API_URL+"/checkout/address/"+userID, {
    credentials: "include",
    headers: {
      "x-access-token": getAccessToken(),
    }
  })
  const data = resp.json();
  // console.log(data);
  return data
}

// on production create the order using stripe webhooks
async function createOrder(user,products, amount, address,paymentMethod,order_id,txn_uuid,txn_orderId,couponAmount,delCharge,gatewayId) {
  const resp = await fetch(API_URL+"/orders", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
    body: JSON.stringify({ 
      // products: products.map(p => ({productID: p.id, quantity: p.quantity})),
      user, 
      products,
      amount, 
      address,
      paymentMethod,
      order_id,
      txn_uuid,
      txn_orderId,
      couponAmount, 
      delCharge,
      gatewayId
    }),
  })
  return await resp.json()
}

async function fetchAllOrders() {
  const userID = getUser()._id
  const resp = await fetch(API_URL+"/orders/user/"+userID, {
    credentials: "include",
    headers: {
      "x-access-token": getAccessToken(),
    }
  })
  return await resp.json()
}

async function fetchOrderDetails(orderID) {
  const resp = await fetch(API_URL+"/orders/"+orderID, {
    credentials: "include",
    headers: {
      "x-access-token": getAccessToken(),
    }
  })
  return await resp.json()
}

async function deleteOrder(orderID) {
  const resp = await fetch(API_URL+"/orders/"+orderID, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "x-access-token": getAccessToken(),
    }
  })
  const data = await resp.json();
  // console.log("order deleted",data);
  return data;
}

async function orderStatus(orderID) {
  const resp = await fetch(API_URL+"/orders/orderStatus/"+orderID, {
    credentials: "include",
    headers: {
      "x-access-token": getAccessToken(),
   }
  })
  const data = await resp.json();
  return data;
}

async function createRazorpayOrder(orderId,user,amount,gatewayId) {
  const resp = await fetch(API_URL+"/payment/razorpay-order", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
    body: JSON.stringify({ 
      orderId,
      user,
      amount,
      gatewayId 
    }),
  })
  return await resp.json()
}

async function razorpayPaymentVerify(paymentDetails,gatewayId) {
  const resp = await fetch(API_URL+"/payment/verify-payment", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
    body: JSON.stringify({ 
     paymentDetails,
     gatewayId
    }),
  })
  return await resp.json()
}

async function razorpayPaymentStatus(paymentId,txnOrderId,orderId,orderTotal,gatewayId) {
  const resp = await fetch(API_URL+`/payment/razstatus/${paymentId}/${txnOrderId}/${orderId}/${orderTotal}/${gatewayId}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
  });
  return await resp.json()
}

async function adcReceipt(orderId,gatewayId) {
  const resp = await fetch(API_URL+`/payment/receipt/${orderId}/${gatewayId}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
  });
  return await resp.json()
}

async function getCoupons(userId) {
  const resp = await fetch(API_URL+`/coupons/${userId}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
  });
  return await resp.json()
}

async function validateCoupon(couponDetails) {
  const resp = await fetch(API_URL+"/coupons/validate", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": getAccessToken(),
    },
    body: JSON.stringify({ 
      id:couponDetails.id,
      code: couponDetails.code,
      total:Number(couponDetails.total),
      userId: couponDetails.userId,
      qty:couponDetails.qty,
    }),
  })
  return await resp.json()
}

async function getWebsiteDetails() {
  const resp = await fetch(API_URL+"/website/details")
  const websiteDetails = await resp.json()
  // console.log("Website Details",websiteDetails);
 return websiteDetails;  
}

async function syncAdcData() {
  try {
    const [productsResp, couponResp, websiteResp, categoryResp,paymentGatewayResp] = await Promise.all([
      fetch(API_URL + "/sync-products",{
        method: "GET",
           credentials: "include",
           headers: {
            "Content-Type": "application/json",
            "x-access-token": getAccessToken(),
           },
       }),
      fetch(API_URL + "/sync-products/coupons",{
        method: "GET",
           credentials: "include",
           headers: {
            "Content-Type": "application/json",
            "x-access-token": getAccessToken(),
           },
       }),
      fetch(API_URL + "/sync-products/websiteDetails",{
        method: "GET",
           credentials: "include",
           headers: {
            "Content-Type": "application/json",
            "x-access-token": getAccessToken(),
          },
       }),
      fetch(API_URL + "/sync-products/categories",{
        method: "GET",
           credentials: "include",
           headers: {
            "Content-Type": "application/json",
            "x-access-token": getAccessToken(),
          },
       }),
      fetch(API_URL + "/sync-products/paymentGateway",{
        method: "GET",
           credentials: "include",
           headers: {
            "Content-Type": "application/json",
            "x-access-token": getAccessToken(),
          },
       }),
    ]);

    // parse JSON in parallel
    const [products, coupons, website, categories,paymentGateway] = await Promise.all([
      productsResp.json(),
      couponResp.json(),
      websiteResp.json(),
      categoryResp.json(),
      paymentGatewayResp.json(),
    ]);

    // console.log("Products synced:", products);
    // console.log("Coupons synced:", coupons);
    // console.log("Website details synced:", website);
    // console.log("Categories synced:", categories);
    // console.log("Payment Gateway synced:", paymentGateway);

    return { products, coupons, website, categories, paymentGateway };
  } catch (error) {
    console.error("Sync failed:", error);
    throw error;
  }
}

export default {
  syncAdcData,
  registerUser,
  loginUser,
  loginGoogleUser,
  logoutUser,
  forgotPassword,
  resetPassword,
  registerUserWithGoogle,
  getUser,
  fetchUserDetails,
  editUser,
  fetchProducts,
  fetchProduct,
  createUserCart,
  getUserCart,
  addProductsToCart,
  removeProductFromCart,
  patchCart,
  clearCart,
  proceedCheckout,
  fetchUserAddress,
  createOrder,
  deleteOrder,
  fetchAllOrders,
  fetchOrderDetails,
  orderStatus,
  createRazorpayOrder,
  razorpayPaymentVerify,
  razorpayPaymentStatus,
  createSession,
  adcReceipt,
  getCoupons,
  validateCoupon,
  updateCart,
  getWebsiteDetails,
  fetchCategories,
  verifyAdminUser,
  sendOtp,
  verifyOtp,
}